/* Dr.Wash — theme.js
   Só o necessário, sem framework: a doc de performance penaliza JS pesado e
   pede conteúdo essencial em Liquid, não em JS. Carregado com `defer`.
   Tudo aqui é melhoria: sem JS, os formulários e links continuam funcionando
   (adicionar recarrega a página, o ícone do carrinho leva para /cart). */
(function () {
  'use strict';

  var rotasEl = document.getElementById('dw-rotas');
  var rotas = rotasEl ? JSON.parse(rotasEl.textContent) : {};
  var ultimoFoco = null;

  function gaveta() { return document.getElementById('cart-drawer'); }

  /* ---- contador do carrinho ------------------------------------------- */
  function atualizaContador(qtd) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = qtd;
      el.hidden = qtd === 0;
    });
  }

  /* ---- abrir e fechar a gaveta ---------------------------------------- */
  function abrir() {
    var el = gaveta();
    if (!el) return;
    ultimoFoco = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('aberta'); });
    document.documentElement.style.overflow = 'hidden';
    var painel = el.querySelector('.gaveta__painel');
    if (painel) painel.focus();
  }

  function fechar() {
    var el = gaveta();
    if (!el || el.hidden) return;
    el.classList.remove('aberta');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { el.hidden = true; }, 220);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  /* ---- recarregar o conteúdo da gaveta (Section Rendering API) --------- */
  function recarrega() {
    return fetch((rotas.root || '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer'];
        var el = gaveta();
        if (!html || !el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var novo = doc.getElementById('cart-drawer');
        if (novo) el.innerHTML = novo.innerHTML;
      });
  }

  function sincroniza() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        atualizaContador(carrinho.item_count);
        document.dispatchEvent(new CustomEvent('dw:carrinho:mudou', { detail: carrinho }));
        return recarrega();
      });
  }

  /* ---- adicionar ao carrinho ------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();

    var botao = form.querySelector('[type="submit"]');
    var textoOriginal = botao ? botao.textContent : '';
    if (botao) { botao.setAttribute('aria-disabled', 'true'); botao.textContent = '...'; }

    function solta() {
      if (botao) { botao.removeAttribute('aria-disabled'); botao.textContent = textoOriginal; }
    }

    fetch(rotas.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(form.querySelector('[name="id"]').value),
          quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1)
        }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add falhou');
        return r.json();
      })
      .then(function () { return sincroniza(); })
      .then(function () { solta(); abrir(); })
      .catch(function () { solta(); form.submit(); });
  });

  /* ---- mexer nas linhas dentro da gaveta ------------------------------- */
  function mudaLinha(linha, quantidade) {
    return fetch(rotas.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(linha), quantity: Number(quantidade) })
    })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        atualizaContador(carrinho.item_count);
        return recarrega();
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { fechar(); return; }

    var abridor = e.target.closest('[data-drawer-open]');
    if (abridor && gaveta()) { e.preventDefault(); abrir(); return; }

    var passo = e.target.closest('[data-line-qty]');
    if (passo) {
      var item = passo.closest('[data-line]');
      var campo = item.querySelector('[data-line-input]');
      var nova = Math.max(0, Number(campo.value || 1) + Number(passo.getAttribute('data-line-qty')));
      mudaLinha(item.getAttribute('data-line'), nova);
      return;
    }

    var remover = e.target.closest('[data-line-remove]');
    if (remover) {
      var alvo = remover.closest('[data-line]');
      mudaLinha(alvo.getAttribute('data-line'), 0);
      return;
    }

    /* + e - fora da gaveta (página de produto) */
    var botao = e.target.closest('[data-qty]');
    if (botao) {
      var input = botao.parentNode.querySelector('input');
      if (!input) return;
      var valor = Number(input.value || 1) + Number(botao.getAttribute('data-qty'));
      input.value = Math.max(Number(input.min || 1), valor);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var campo = e.target.closest('[data-line-input]');
    if (!campo) return;
    var item = campo.closest('[data-line]');
    mudaLinha(item.getAttribute('data-line'), Math.max(0, Number(campo.value || 0)));
  });

  /* ---- teclado: Esc fecha, Tab não escapa do painel ------------------- */
  document.addEventListener('keydown', function (e) {
    var el = gaveta();
    if (!el || el.hidden) return;
    if (e.key === 'Escape') { fechar(); return; }
    if (e.key !== 'Tab') return;

    var focaveis = el.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
    if (!focaveis.length) return;
    var primeiro = focaveis[0];
    var ultimo = focaveis[focaveis.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  });

  /* ---- menu mobile ----------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-menu-toggle]');
    if (!burger) return;
    var alvo = document.getElementById(burger.getAttribute('aria-controls'));
    if (!alvo) return;
    var aberto = burger.getAttribute('aria-expanded') === 'true';
    burger.setAttribute('aria-expanded', String(!aberto));
    alvo.hidden = aberto;
  });
})();
